import { i18n } from 'src/i18n';

class Roles {
  static get values() {
    return {
      sub_admin: 'sub_admin',
      admin: 'admin',
      owner: 'owner',
      supervisor: 'supervisor',
      dashboard_viewer: 'dashboard_viewer',
    };
  }

  static labelOf(roleId) {
    if (!this.values[roleId]) {
      return roleId;
    }

    return i18n(`roles.${roleId}.label`);
  }

  static descriptionOf(roleId) {
    if (!this.values[roleId]) {
      return roleId;
    }

    return i18n(`roles.${roleId}.description`);
  }
}

export default Roles;
